import { useContext } from 'react';
import { useIntl } from '@alltrails/shared/react-intl';
import SearchOrigin from '@alltrails/analytics/enums/SearchOrigin';
import { AlgoliaSearchBox } from '@alltrails/modules/AlgoliaSearch';
import useExperiments from 'hooks/useExperiments';
import '@alltrails/modules/AlgoliaSearch/index.css';
import { SearchInsightsContext } from 'components/SearchInsightsProvider';
import useUser from 'hooks/useUser';
import useLanguageRegionCode from '@alltrails/shared/hooks/useLanguageRegionCode';
import * as styles from './HomeSearchBar.module.scss';

export default function HomeSearchBar() {
  const intl = useIntl();
  const languageRegionCode = useLanguageRegionCode();
  const user = useUser();
  const experiments = useExperiments();
  const aiSearchEnabled = experiments['web-ai-natural-language-search']?.value === 'treatment';

  const { updateSearchId, logClickEvent } = useContext(SearchInsightsContext);

  return (
    <div className={styles.container}>
      <AlgoliaSearchBox
        className={styles.search}
        configs={global.__AT_DATA__.algoliaConfig}
        isMobileBrowser={global.__AT_DATA__.mobileBrowser}
        languageRegionCode={languageRegionCode}
        aiSearchEnabled={aiSearchEnabled}
        navigateOnSelect
        onResultSelect={(result, additionalInfo) => {
          if (result && additionalInfo) {
            logClickEvent(result.objectID, additionalInfo.index + 1);
          }
        }}
        onSearch={response => {
          if (response?.queryID) {
            updateSearchId(response.queryID);
          }
        }}
        placeholder={intl.formatMessage({ defaultMessage: 'Search by city, park, or trail name' })}
        searchOrigin={SearchOrigin.Homepage}
        searchTypes="all"
        size="homepage"
        testId="homepage-search-box"
        useTypeAhead
        user={user}
      />
    </div>
  );
}
